import React, { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import SearchableSelect from "./SearchableSelect";

const PrenotazioneUpdateOffcanvas = ({
  showUpdate,
  handleCloseUpdate,
  newGiorno,
  setNewGiorno,
  nome_tappa_inizio,
  nome_tappa_fine,
  tappe_all,
  strutture,
  token,
  updatecammino,
  getAlloggi,
  setAlloggi,
  setAlloggiBackup,
  setModalError,
  setModalSuccess,
  id_cammino,
  id_prenotazione_,
  refreshPrenotazioni,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const checkIfStruttureIsActive = (alloggio_ritiro, alloggio_consegna) => {
    if (
      strutture.find(
        (s) => s.id === parseInt(alloggio_ritiro) && (s.attivo === 0 || s.attivo === 2)
      ) &&
      strutture.find(
        (s) => s.id === parseInt(alloggio_consegna) && (s.attivo === 0 || s.attivo === 2)
      )
    )
      return true;
    return false;
  };
  const handleUpdate = async () => {
    if (submitting) return;
    if (
      !checkIfStruttureIsActive(
        newGiorno.alloggio_ritiro,
        newGiorno.alloggio_consegna
      )
    ) {
      setModalError("Una delle strutture selezionate non è attiva");
      return;
    }
    setSubmitting(true);
    try {
      let resultInsert = await updatecammino(
        token,
        newGiorno.id_prenotazione,
        newGiorno.id_tappa_prenotazione,
        newGiorno.stato_prenotazione,
        newGiorno.data,
        newGiorno.costo,
        newGiorno.bagagli,
        newGiorno.tappa_inizio,
        newGiorno.tappa_fine,
        newGiorno.alloggio_ritiro,
        newGiorno.alloggio_consegna
      );
      const ok = resultInsert && typeof resultInsert.status === "number" && resultInsert.status >= 200 && resultInsert.status < 300;
      if (ok) {
        await setModalError(false);
        let result_post_update = await getAlloggi(token);
        setAlloggi(result_post_update);
        setAlloggiBackup(result_post_update);
        if (refreshPrenotazioni) await refreshPrenotazioni();
        handleCloseUpdate();
        if (setModalSuccess) setModalSuccess("Tappa aggiornata con successo");
      } else {
        setModalError("Errore durante l'aggiornamento della tappa");
      }
    } catch (e) {
      setModalError("Errore durante l'aggiornamento della tappa");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Offcanvas
      className="offcanvas-custom"
      placement="end"
      show={showUpdate}
      onHide={handleCloseUpdate}
    >
      <Offcanvas.Header>
        <img
          onClick={handleCloseUpdate}
          className="btn-close-img"
          src="/closeBtn.svg"
        />
        <p
          style={{
            color: "#B1B1B1",
            fontSize: "2em",
            marginBottom: "0",
            position: "absolute",
            left: "60px",
          }}
        >
          Prenotazioni - Modifica
        </p>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div style={{ paddingLeft: "35px", paddingRight: "35px" }}>
          <h1
            style={{
              fontSize: "1.3em",
              fontWeight: "700",
              marginBottom: "0",
              marginTop: "30px",
            }}
          >
            Modifica
          </h1>
          <h2 style={{ fontSize: "1.6em", fontWeight: "300" }}>
            {nome_tappa_inizio} - {nome_tappa_fine}
          </h2>
          <div>
            <div>
              <div>
                <div className="md-form  mb-2">
                  <i className="fas fa-user prefix grey-text"></i>
                  <b>Stato Prenotazione</b>
                  <select
                    onChange={async (e) => {
                      await setNewGiorno({
                        ...newGiorno,
                        stato_prenotazione: e.target.value,
                      });
                    }}
                    value={newGiorno.stato_prenotazione}
                    type="text"
                    id="orangeForm-name"
                    className="form-control validate"
                  >
                    <option value={3}>In attesa di conferma</option>
                    <option value={1}>Pagato</option>
                    <option value={2}>Annullato</option>
                    <option value={4}>Non pagato</option>
                  </select>
                  <label
                    data-error="wrong"
                    data-success="right"
                    htmlFor="orangeForm-name"
                  >
                    Costo
                  </label>
                  <input
                    onChange={async (e) => {
                      await setNewGiorno({
                        ...newGiorno,
                        costo: e.target.value,
                      });
                    }}
                    value={newGiorno.costo}
                    type="number"
                    id="orangeForm-name"
                    className="form-control validate"
                  />

                  <label
                    data-error="wrong"
                    data-success="right"
                    htmlFor="orangeForm-name"
                  >
                    Data
                  </label>
                  <input
                    onChange={async (e) => {
                      await setNewGiorno({
                        ...newGiorno,
                        data: e.target.value,
                      });
                    }}
                    value={
                      newGiorno.data
                        ? new Date(newGiorno.data).toISOString().split("T")[0]
                        : ""
                    }
                    type="date"
                    id="orangeForm-name"
                    className="form-control validate"
                  />

                  <label
                    data-error="wrong"
                    data-success="right"
                    htmlFor="orangeForm-name"
                  >
                    Tappa d'inizio
                  </label>
                  <SearchableSelect
                    options={tappe_all}
                    value={newGiorno.tappa_inizio}
                    getLabel={(t) => `${t.id} - ${t.nome}`}
                    getValue={(t) => t.id}
                    placeholder="Cerca una tappa..."
                    onSelect={(t) =>
                      setNewGiorno({
                        ...newGiorno,
                        tappa_inizio: t.id,
                        nome_tappa_inizio: t.nome,
                      })
                    }
                  />

                  <label
                    data-error="wrong"
                    data-success="right"
                    htmlFor="orangeForm-name"
                  >
                    Tappa di fine
                  </label>
                  <SearchableSelect
                    options={tappe_all}
                    value={newGiorno.tappa_fine}
                    getLabel={(t) => `${t.id} - ${t.nome}`}
                    getValue={(t) => t.id}
                    placeholder="Cerca una tappa..."
                    onSelect={(t) =>
                      setNewGiorno({
                        ...newGiorno,
                        tappa_fine: t.id,
                        nome_tappa_fine: t.nome,
                      })
                    }
                  />

                  <label
                    data-error="wrong"
                    data-success="right"
                    htmlFor="orangeForm-name"
                  >
                    Struttura di ritiro
                  </label>
                  {strutture.find(
                    (s) => s.id == newGiorno.alloggio_ritiro && s.attivo == 0
                  ) ? null : (
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "orange",
                        display: "block",
                      }}
                    >
                      Struttura da confermare
                    </span>
                  )}
                  <SearchableSelect
                    options={strutture.filter(
                      (s) =>
                        s.id_tappa == newGiorno.tappa_inizio &&
                        (s.attivo == 0 || s.attivo == 2)
                    )}
                    value={newGiorno.alloggio_ritiro}
                    getLabel={(a) =>
                      `${a.id} - ${a.nome}${a.attivo !== 0 ? " ⚠️ (Da confermare)" : ""}`
                    }
                    getValue={(a) => a.id}
                    placeholder={
                      newGiorno.tappa_inizio
                        ? "Cerca un alloggio..."
                        : "Seleziona prima la tappa d'inizio"
                    }
                    disabled={!newGiorno.tappa_inizio}
                    onSelect={(a) =>
                      setNewGiorno({
                        ...newGiorno,
                        alloggio_ritiro: a.id,
                      })
                    }
                  />

                  <label
                    data-error="wrong"
                    data-success="right"
                    htmlFor="orangeForm-name"
                    disabled={newGiorno.tappa_fine ? true : false}
                  >
                    Struttura di consegna
                    {strutture.find(
                      (s) =>
                        s.id == newGiorno.alloggio_consegna && s.attivo == 0
                    ) ? (
                      ""
                    ) : (
                      <span
                        style={{
                          fontWeight: "bold",
                          color: "orange",
                          display: "block",
                        }}
                      >
                        Struttura da confermare
                      </span>
                    )}
                  </label>
                  <SearchableSelect
                    options={strutture.filter(
                      (s) =>
                        s.id_tappa == newGiorno.tappa_fine &&
                        (s.attivo == 0 || s.attivo == 2)
                    )}
                    value={newGiorno.alloggio_consegna}
                    getLabel={(a) =>
                      `${a.id} - ${a.nome}${a.attivo !== 0 ? " ⚠️ (Da confermare)" : ""}`
                    }
                    getValue={(a) => a.id}
                    placeholder={
                      newGiorno.tappa_fine
                        ? "Cerca un alloggio..."
                        : "Seleziona prima la tappa di fine"
                    }
                    disabled={!newGiorno.tappa_fine}
                    onSelect={(a) =>
                      setNewGiorno({
                        ...newGiorno,
                        alloggio_consegna: a.id,
                      })
                    }
                  />

                  <label
                    data-error="wrong"
                    data-success="right"
                    htmlFor="orangeForm-name"
                  >
                    Numero Bagagli
                  </label>
                  <input
                    onChange={async (e) => {
                      await setNewGiorno({
                        ...newGiorno,
                        bagagli: e.target.value,
                      });
                    }}
                    value={newGiorno.bagagli}
                    type="number"
                    id="orangeForm-name"
                    className="form-control validate"
                  />
                </div>
              </div>
              <div className="">
                <button
                  onClick={handleUpdate}
                  disabled={submitting}
                  className="btn btn-deep-orange close btn-update"
                  data-dismiss="modal"
                  aria-label="Close"
                  style={submitting ? { opacity: 0.6, cursor: "wait" } : undefined}
                >
                  {submitting ? "Salvataggio in corso…" : "Salva"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PrenotazioneUpdateOffcanvas;
